import request from 'src/utils/request';

/**
 * 获取轮播图列表
 * @param {Object} params - 请求参数
 * @param {string} params.pageIndex - 当前页码（可选）
 * @param {string} params.pageSize - 每页数据量（可选）
 * @returns {Promise}
 */
export const getBannerList = (params) => {
    return request.get('/public/SysBanner/GetEnabledList', params);
};